const ATCConfig = {
    API_BASE: process.env.REACT_APP_API_BASE || '',
    CLAIM_CONTRACT: process.env.REACT_APP_CONTRACT_CLAIM || '',
    ERC20_CONTRACT: process.env.REACT_APP_CONTRACT_ERC20 || '',
    RPC_URL: process.env.REACT_APP_RPC_URL || ''
};

export default ATCConfig;
